import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { SaveMission } from '../../../store/actions/mission.actions';
import { LineInterface } from '../../../../lines/models/line.interface';

@Component({
  selector: 'app-surtax-number',
  templateUrl: './surtax-number.component.html',
  styleUrls: ['./surtax-number.component.css'],
  standalone: false
})
export class SurtaxNumberComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  blockStatus: boolean;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.formSubmitted = false;
    if (this.line.optionsStatus.surtax_number === 'blocking_in_progress' || this.line.optionsStatus.surtax_number === true) {
      this.blockStatus = true;
    } else if (this.line.optionsStatus.surtax_number === 'unblocking_in_progress' || this.line.optionsStatus.surtax_number === false) {
      this.blockStatus = false;
    } else {
      this.blockStatus = true;
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new SaveMission({
        step: 1,
        active: this.blockStatus,
        phoneNumber: this.line.phoneNumber
      }, this.procedureCode));
    }
  }
}
